// ============================================================================
// OBT F3 — İstemci ön-doğrulama (backend nihai otoritedir)
// ============================================================================
// Bu kontroller yalnız kullanıcıya erken geri bildirim içindir. Sunucu her
// durumda kendi kurallarını yeniden uygular (rol/scope/durum/uzunluk).
// ============================================================================

// Backend uzunluk sınırlarıyla hizalı ön-kapılar (nihai otorite backend).
export const MAX_COMMENT_LEN = 2000;
export const MAX_DECISION_TEXT_LEN = 8000;

/** Zorunlu yorum/gerekçe alanı geçerli mi (boş/whitespace reddedilir). */
export function isRequiredCommentValid(text) {
  return typeof text === 'string' && text.trim().length > 0 && text.length <= MAX_COMMENT_LEN;
}

/** Opsiyonel yorum geçerli mi (boş serbest; doluysa sınır içinde). */
export function isOptionalCommentValid(text) {
  if (text == null || text === '') return true;
  return typeof text === 'string' && text.length <= MAX_COMMENT_LEN;
}

/**
 * Nihai karar item'ının gerekçesi zorunlu mu?
 * Ürün kuralı (§17): DAHİL ETME dışı kararlarda (çıkarma/erteleme) gerekçe
 * zorunludur; "dahil et" için gerekçe opsiyoneldir.
 * @param {string} decision  backend değeri: selected|not_selected|postponed
 */
export function isDecisionExplanationRequired(decision) {
  return decision === 'not_selected' || decision === 'postponed';
}

/** Karar item'ı gönderilebilir mi (gerekçe kuralı + uzunluk). */
export function isDecisionItemValid(decision, explanation) {
  if (!decision) return false;
  const text = typeof explanation === 'string' ? explanation : '';
  if (text.length > MAX_DECISION_TEXT_LEN) return false;
  if (isDecisionExplanationRequired(decision)) {
    return text.trim().length > 0;
  }
  return true;
}

/**
 * Set en az bir KARARLI item taşıyor mu? Backend boş seti reddeder; bu, ürün
 * gate'inin bir parçasıdır (tek başına yeterli DEĞİL — bkz. allCandidatesDecided).
 * @param {{items?: Array}} decisionSet
 */
export function hasDecidedItems(decisionSet) {
  const items = Array.isArray(decisionSet?.items) ? decisionSet.items : [];
  return (
    items.length > 0 &&
    items.every((it) => typeof it?.decision === 'string' && it.decision.length > 0)
  );
}

/**
 * TÜM aday parklar (Müdür kuyruğundan) karara bağlanmış mı? Backend finalize
 * yalnız boş seti engeller; "tüm adaylar karara bağlı olmalı" ürün kuralı (§16)
 * frontend'de uygulanır. Aday response_id'lerinin HEPSİ set item'larında
 * geçerli bir karar taşımalıdır.
 * @param {Array<{response_id: string}>} candidates  Müdür kuyruğundan aday cevaplar
 * @param {Array<{response_id: string, decision?: string}>} items  karar seti item'ları
 */
export function allCandidatesDecided(candidates, items) {
  const list = Array.isArray(candidates) ? candidates : [];
  if (list.length === 0) return false;
  const decided = new Map(
    (Array.isArray(items) ? items : [])
      .filter((it) => typeof it?.decision === 'string' && it.decision.length > 0)
      .map((it) => [String(it.response_id), it.decision])
  );
  return list.every((c) => decided.has(String(c.response_id)));
}

/** Finalize'a hazır mı: en az bir aday var VE hepsi karara bağlı. */
export function canFinalize(candidates, items) {
  return allCandidatesDecided(candidates, items);
}
